import { render, staticRenderFns } from "./ListChip.vue?vue&type=template&id=54665390&scoped=true&"
import script from "./ListChip.vue?vue&type=script&lang=js&"
export * from "./ListChip.vue?vue&type=script&lang=js&"
import style0 from "./ListChip.vue?vue&type=style&index=0&id=54665390&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54665390",
  null
  
)

export default component.exports